import type { AppTheme } from '../../theme';
import type { CSSProperties } from 'react';
export const previewFrameStyle = (width: number): CSSProperties => ({ position: 'fixed', left: -20000, top: -20000, width, height: 1200, border: 0, pointerEvents: 'none' });

export const previewSourceStyle = (width: number, detached: boolean): CSSProperties => detached
  ? { position: 'fixed', left: -20000, top: -20000, width, height: 1200, pointerEvents: 'none' }
  : { display: 'flex', flexDirection: 'column', minHeight: 500, width: '100%', pointerEvents: 'none' };

export const previewErrorStyle = (theme: AppTheme): CSSProperties => ({ backgroundColor: theme.colors.card, color: theme.colors.text, border: `1px solid ${theme.colors.border}` });
